import React, { useRef, useState, useEffect } from "react";
import { useLockFn } from "ahooks";
import { Button, Form, Image } from "antd";
import { YhForm } from "@components/YhFormBox";
import { YhBox } from "@src/components/YhBox";
import { useNavModel, RouterParamType } from "@src/model/navModel";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@components/YhFormBox/Types";
import { UploadOutlined } from '@ant-design/icons';
import { getBaseImgUploadUrl, getBaseUploadData, getBaseImgLookUrl } from "@src/utils/constants";
import { rosterDetailsModels } from "./rosterDetailsModels";
import { rosterService } from "../../rosterService";
import { globalPrompt } from "@src/components/YhMessage";
import YhUploadForm from "@src/components/YhUploadForm";

export const OtherInfo: React.FC = () => {
  const { getSelectedNavState } = useNavModel();
  const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
  const { id, mode } = detailsInfo;
  const {
    getDetail, getFormInfo, onCancel,
  } = rosterDetailsModels();

  useEffect(() => {
    if (mode === "edit") {
      getDetail(id, mode);
    }
  }, [detailsInfo]);

  const formRef = useRef<IYhFormRef>();
  const formConfig: IYhForm = {
    formRef,
    labelCol: { span: 3 },
    disabled: false,
    justify: 'start',
    items: [
      {
        type: FormItemTypeEnum.Other,
        fieldLabel: "五大档案",
        fieldName: "file1",
        colClassName: "ant-col-h-auto",
        span: 12,
        formItem:
          <div className="otherFileStyle">
            <YhUploadForm
              name="mainFileList"
              label="五大档案"
              maxCount={100}
              listType="picture"
              initialValue={getFormInfo(mode)?.mainFileList}
              fileUrl={getBaseImgLookUrl}
              action={getBaseImgUploadUrl()}
              uploadData={getBaseUploadData()}
              uploadButton={<Button icon={<UploadOutlined />}>选择文件上传</Button>}
            />
          </div>
      },
      {
        type: FormItemTypeEnum.Other,
        fieldLabel: "相关文档",
        fieldName: "file2",
        colClassName: "ant-col-h-auto",
        span: 12,
        formItem:
          <div className="otherFileStyle">
            <YhUploadForm
              name="extraFileList"
              label="相关文档"
              maxCount={100}
              listType="picture"
              initialValue={getFormInfo(mode)?.extraFileList}
              fileUrl={getBaseImgLookUrl}
              action={getBaseImgUploadUrl()}
              uploadData={getBaseUploadData()}
              uploadButton={<Button icon={<UploadOutlined />}>选择文件上传</Button>}
            />
          </div>
      },
    ]
  };

  const onSave = useLockFn(async () => {
    try {
      const formData = await formRef.current?.validateFields();
      if (formData) {
        const mainFileList = formData.mainFileList?.map((item: any) => ({ type: "five_major_files", imgUrl: item.uid, imgName: item.name }));
        const extraFileList = formData.extraFileList?.map((item: any) => ({ type: "related_files", imgUrl: item.uid, imgName: item.name }));
        const params = {
          "employeeId": id,
          "userFileList": [...mainFileList, ...extraFileList]
        }
        let ret = await rosterService.fileInsert(params);
        if (ret.success) {
          await globalPrompt("message", { type: "success", text: '保存成功!' });
        } else {
          await globalPrompt("message", { type: "error", text: "保存失败!" + ret.retMsg });
        }
      }
    } catch (e) {
      console.log("失败!");
    }
  })

  const action = (
    <>
      <Button className="mr-5" type="link" shape="round" onClick={() => { onSave() }}>保存</Button>
      <Button className="mr-5" type="link" shape="round" onClick={() => { onCancel(mode) }}>取消</Button>
    </>
  );

  return (
    <YhBox action={action} style={{ overflowY: 'auto', padding: 10, margin: 10 }}>
      <div style={{ marginBottom: 10, padding: 10, fontSize: 18, fontWeight: "bold" }}>其他信息</div>
      <YhForm  {...formConfig} />
    </YhBox>
  );
}